import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LazySize from 'src/components/LazySize';
import ProgressPlaceholder from 'src/images/progressPlaceholder.png';

// ----------------------------------------------------------------------

CompanyAccountAvatar.propTypes = {
  className: PropTypes.string
};

function CompanyAccountAvatar({ className, logo, ...other }) {
  return (
    <LazySize
      src={logo || ProgressPlaceholder}
      sx={{
        width: 40,
        height: 40,
        borderRadius: 40,
        border: 'solid 1px #e4e8eb'
      }}
    />
  );
}

export default CompanyAccountAvatar;
